import { Component, DoCheck, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { CustomElement } from '../../classes';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextareaComponent),
    multi: true
};

@Component({
    selector: 'chassis-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class TextareaComponent extends CustomElement implements OnInit, DoCheck {

    @Input() cols: number = null;

    @Input() maxlength: number = null;

    @Input() placeholder = '';

    @Input() rows: number = 5;

    @Input() wrap: boolean = null;

    @Input() value: string = null;

    @Input() wysiwyg: boolean;

    @Input() settings: any = {};

    @Input() toolbar: Array<any> = null;

    @Input() shortcuts: boolean;

    @Input() fonts: Array<string> = null;

    @Output() init = new EventEmitter();

    @Output() enter = new EventEmitter();

    @Output() focus = new EventEmitter();

    @Output() blur = new EventEmitter();

    @Output() keyup = new EventEmitter();

    @Output() keydown = new EventEmitter();

    @Output() paste = new EventEmitter();

    @Output() upload = new EventEmitter();

    @Output() change = new EventEmitter();

    protected summernote;

    ngOnInit() {
        super.ngOnInit();

        if (this.wysiwyg) {
            this.initWysiwygSettings();

            // Wait till the class has initialized
            setTimeout(() => {
                this.initWysiwyg();
            }, 0);
        }
    }

    protected executeMutators() {
        super.executeMutators();

        this.wysiwyg = this.wysiwyg !== undefined && this.wysiwyg !== false;
    }

    protected initWysiwygSettings() {

        if (this.toolbar) {
            this.settings.toolbar = this.toolbar;
        }

        this.settings.placeholder = this.placeholder;
        this.settings.height      = this.rows ? this.rows * 20 : 100;

        if (this.shortcuts) {
            this.settings.shortcuts = this.shortcuts;
        }

        if (this.fonts) {
            this.settings.fonts = this.fonts;
        }
    }

    protected initWysiwyg() {
        const summernote = this.summernote = (<any>$('.textarea#' + this.id));

        summernote.summernote(this.settings);

        this.setInitialValue(summernote);

        // on summernote change
        summernote.on('summernote.change', () => {
            if (summernote.summernote('code') !== this.val) {
                this.val = summernote.summernote('code');
            }
        });

        // on input model change
        this.change.subscribe(value => {
            if (summernote.summernote('code') !== value) {
                summernote.summernote('code', value);
            }
        });

        summernote.parent().first('.note-codable').on('keyup', () => {
            this.val = summernote.summernote('code');
        });

        if (this.autofocus) {
            summernote.summernote('focus');
        }

        if (this.disabled || this.readonly) {
            summernote.summernote('disable');
        }

        this.initWysiwygEventEmitters(summernote);
    }

    protected setInitialValue(summernote) {
        const self = this;
        summernote.val(self.value);
    }

    ngDoCheck() {
        if (this.val === undefined) {
            if (this.summernote) {
                this.summernote.summernote('reset');
            }
        }
    }

    protected initWysiwygEventEmitters(summernote) {
        summernote.on('summernote.init', () => {
            this.init.emit();
        });
        summernote.on('summernote.enter', () => {
            this.enter.emit();
        });
        summernote.on('summernote.focus', () => {
            this.focus.emit();
        });
        summernote.on('summernote.blur', () => {
            this.blur.emit();
        });
        summernote.on('summernote.keyup', () => {
            this.keyup.emit();
        });
        summernote.on('summernote.keydown', () => {
            this.keydown.emit();
        });
        summernote.on('summernote.paste', () => {
            this.paste.emit();
        });
        summernote.on('summernote.upload', () => {
            this.upload.emit();
        });
        summernote.on('summernote.change', () => {
            // this.change.emit();
        });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/components/textarea/textarea.component.ts